// GENERATED by scripts/build-icons.mjs from icons/rows-2.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const Rows2 = createIcon('rows-2', [
  ['rect', { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
  ['path', { d: "M3 12h18" }],
])
